import React from 'react';
import { CreatePage } from '@components/common';
import CategoryForm from '../CategoriesPage/CategoryForm';

const CategoryCreatePage = () => {
    return (
        <CreatePage
            modelName="categories"
            FormComponent={CategoryForm}
        />
    );
};

export default CategoryCreatePage;
